const BACKOFF = 0.05;
const FREQUENCY_CEILING = 10000;

export default class Poller {
  constructor(pollAction, check, dispatch, frequency, expoBackoff = true) {
    // pollaction returns a Promise
    this.pollAction = pollAction;
    this.check = check;
    this.dispatch = dispatch;
    this.frequency = frequency;
    this.exponentialBackoff = expoBackoff;
    this.result = null;
    this.done = false;
  }

  increaseFrequency() {
    if(this.frequency <= FREQUENCY_CEILING) {
      this.frequency += Math.ceil(this.frequency * BACKOFF);
    }
  }

  poll() {
    setTimeout(this.fetchResponse.bind(this), this.frequency);  // run
  }

  fetchResponse() {
    this.pollAction().then(function(response) {
      this.result = response;
      if(this.check(this.result)) {
        this.done = true;
        this.dispatch();
      } else {
        this.increaseFrequency();
        setTimeout(this.fetchResponse.bind(this), this.frequency);
      }
    }.bind(this))
  }
}
